import React, { Component } from "react"
import fakeTrees from "./defaultTree"
import Page from "features/editor/page"
import { TreeInstance } from "./tree/tree"

const { emptyPage, customBlock } = fakeTrees

/**
 * @augments {Component<{tree?: TreeInstanceType, onChange?}>}
 */
export default class EditorV2 extends Component {
    state = { tree: {} }
    render() {
        console.log("remaking")
        return (
            <Page
                saveTree={() => this.props.onChange({ blocks: this.state.tree.getBlocks() })}
                onChange={this.props.onChange}
                tree={this.state.tree}
                page={this.props.page}
                allowEdits
            />
        )
    }

    constructor(props) {
        super(props)
        this.state.tree = treeOrEmpty(props)
    }

    // componentWillReceiveProps(newProps) {
    //     console.count("EditorV2.componentWillReceiveProps.JSON.stringify")
    //     if (JSON.stringify(newProps.page) != JSON.stringify(this.props.page)) {
    //         this.setState({ tree: treeOrEmpty(newProps) })
    //     }
    // }
}
const treeOrEmpty = props =>
    props.page && isValidTree(props.page.blocks)
        ? new TreeInstance(JSON.parse(JSON.stringify(props.page.blocks)))
        : props.isCustomBlock
            ? customBlock
            : emptyPage
const isValidTree = obj => Array.isArray(obj)



// WEBPACK FOOTER //
// ./src/features/editor/index.js